import AppConstants from "@/constants/AppConstants";
import DataTypes from "@/constants/DataTypes";
import { isFormFieldElementType } from "@/constants/FormFieldConstants.mjs";
import {
  HANDLE_MODE_ALL,
  HANDLE_MODE_ASPECT_RATIO,
  HANDLE_MODE_ASPECT_RATIO_W_ROTATION,
  HANDLE_MODE_HORIZONTAL,
} from "@/constants/HandleModeConstants.mjs";
import { CROP_MODE } from "@/constants/UIConstants";
import BlockUtils from "@/utils/BlockUtils";

const { ELEMENT_TYPE_LINE } = AppConstants;

/**
 * Whether the transformer should offer only the side handles for an element: a line, or a form
 * field, whose height its widget sets. A multi-line input's textarea fills the height it is given,
 * so it keeps every handle.
 * @param {ImmutableMap} [element] - The selected element, as stored in the block.
 * @returns {boolean}
 */
export const isWidthOnlyElement = (element) => {
  const type = element?.get("type");

  return (
    type === ELEMENT_TYPE_LINE ||
    (isFormFieldElementType(type) && !element.getIn(["content", "multiLine"]))
  );
};

/**
 * The transformer's handles for the stage selection.
 * @param {string} mode - The stage's mode, e.g. `CROP_MODE`.
 * @param {ImmutableMap} selectedBlock - The block holding the selection.
 * @returns {import("@/constants/HandleModeConstants.mjs").HandleMode}
 */
export const getHandleMode = (mode, selectedBlock) => {
  if (mode === CROP_MODE) return HANDLE_MODE_ASPECT_RATIO;

  const selectedElements = selectedBlock.getIn(["selected", "elements"]);
  if (selectedElements?.size !== 1) return HANDLE_MODE_ALL;

  const selection = selectedElements.first();
  if (selection.type === DataTypes.GROUP) return HANDLE_MODE_ASPECT_RATIO_W_ROTATION;

  return isWidthOnlyElement(BlockUtils.getBlockElement(selectedBlock, selection.id))
    ? HANDLE_MODE_HORIZONTAL
    : HANDLE_MODE_ALL;
};
